import React, { useState } from "react"
import { Container, Card, CardBody } from "reactstrap"
import MetaTags from 'react-meta-tags';

import * as reportsApi from '../../apis/reportsApi';
import PageTitle from "../../components/Common/PageTitle"
import FilterText from "./FilterComponent/FilterText";
import FilterCompany from "./FilterComponent/FilterCompany"
import FilterFromToDate from "./FilterComponent/FilterFromToDate"
import ReportBody from "./ReportPartials/ReportBody";
import ReportButton from "./ReportPartials/ReportButton";
import ReportButtonContainer from "./ReportPartials/ReportButtonContainer";


function BcKhoLichSuNhapXuat() {

  const [dataHead, setDataHead] = useState([]);
  const [dataBody, setDataBody] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState();
  const [productCode, setProductCode] = useState();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  const handleChangeCompany = (value) => {
    setSelectedCompany(value);
  };

  const handleChangeProductCode = (value) => {
    setProductCode(value);
  };

  const handleChangeFromDate = (value) => {
    setFromDate(value);
  };

  const handleChangeToDate = (value) => {
    setToDate(value);
  };
    
  const renderTable = () => {
    if (selectedCompany === undefined) { alert("Chọn hệ thống cửa hàng"); return; }
    if ((productCode === undefined) || (productCode.length === 0)) { alert("Nhập mã sản phẩm"); return; }

    const params = [
        { name: "company_id", value: selectedCompany },
        { name: "code", value: productCode },
        { name: "from_date", value: fromDate },
        { name: "to_date", value: toDate }
    ];
    reportsApi.getDataReportsLichSuNhapXuat(params, getDataView, showErr);
  }

  const getDataView = (res) => {
    setDataHead(res?.data?.data?.headers);
    setDataBody(res?.data?.data?.details);
  }

  const showErr = (res) => {
    alert(res.message);
  }

  return (
    <React.Fragment>
      <div className="page-content">
      <MetaTags>
          <title>Lịch sử nhập xuất SP</title>
        </MetaTags>
        <Container fluid>
          <PageTitle title="Lịch sử nhập xuất sản phẩm" />
            <Card>
              <CardBody>
                <FilterCompany
                  onChange={handleChangeCompany} />

                <FilterText
                  label="Mã sản phẩm"
                  onChange={handleChangeProductCode} />

                <FilterFromToDate
                  onChangeFromDate={handleChangeFromDate}
                  onChangeToDate={handleChangeToDate} />
                
                <ReportButtonContainer>
                  <ReportButton
                    label='Xem báo cáo'
                    onClick={renderTable} />
                </ReportButtonContainer>
                
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <ReportBody 
                  dataHead={dataHead}
                  dataBody={dataBody} />
              </CardBody>
            </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BcKhoLichSuNhapXuat
